import { ResponsiveImage } from '@/components/elements/ResponsiveImage';
import { ITestimonial, IUploadFileEntityResponse } from '@/graphql/__generated__/global/types';
import { getImageUrl } from '@/lib/getImageUrl';
import { Icon } from '../../global/Icons';

/**
 * We need to make the image prop optional because the image is optional in the
 * testimonial type. We need to do this because we can't use the same type for
 * the testimonial block and the testimonial component.
 */
interface Props extends Omit<ITestimonial, 'image'> {
    image?: IUploadFileEntityResponse;
}

function addStar(rating: number) {
    const iterations = 5;
    const stars = [];

    for (let i = 0; i < iterations; i++) {
        if (i < Math.floor(rating)) {
            stars.push(<Icon key={i} id={'full-star'} className="w-5 h-5 fill-primary" />);
        } else if (i === Math.floor(rating) && rating % 1 !== 0) {
            stars.push(<Icon key={i} id={'half-star'} className="w-5 h-5 fill-primary" />);
        } else {
            stars.push(<Icon key={i} id={'empty-star'} className="w-5 h-5 fill-primary" />);
        }
    }

    return stars;
}

export const TestimonialCard = ({ quote, author, image, rating }: Props) => {
    const nearestHalfRating = (rating && Math.round(rating * 2) / 2) || 5;
    const stars = addStar(nearestHalfRating);

    return (
        <div className="embla__slide text-primary">
            <div className="grid grid-cols-1 md:grid-cols-2">
                {image && (
                    <ResponsiveImage
                        alt="Testimonial image"
                        aspectRatio={5 / 4}
                        src={getImageUrl(image)}
                        className="rounded-2xl"
                        sizes={`(max-width: 767px) 85vw, (max-width: 1919px) 45vw, 842px`}
                    />
                )}
                <div className="flex items-center p-8">
                    <div className="relative text-primary pt-8">
                        <div>
                            <div className="flex gap-1 relative bottom-2 h-5">{stars}</div>
                        </div>
                        <h4 className="mb-8 mt-4">&#8246;{quote}&#8243;</h4>
                        <h6>{author}</h6>
                    </div>
                </div>
            </div>
        </div>
    );
};
